import {getStorageSnapshot} from './auth';

// monitor (admin account defaults to this role)
export type CustomerKind = 'monitor' | 'client' | 'monitoring' | 'partner';

// TODO: implement a way to programatically get the current customer kind
// even outside of a component
export const isCustomerXPTO = () => {
  //
};

export const getCurrentCustomerId = (): number | undefined => {
  return getStorageSnapshot().auth.user.customerId;
};
